const retryDelaysMs = [1500, 2000, 2500, 3000, 3500, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000, 30000];

const FAST_COMPLETION_WINDOW_MS = 5 * 60 * 1000;
const FAST_COMPLETION_MAX_DELAY_MS = 12000;

export function generationPollDelayMs(attempt: number, elapsedMs: number): number {
  const safeAttempt = Number.isFinite(attempt) ? Math.max(0, Math.floor(attempt)) : 0;
  const safeElapsed = Number.isFinite(elapsedMs) ? Math.max(0, elapsedMs) : 0;
  const scheduled = retryDelaysMs[Math.min(safeAttempt, retryDelaysMs.length - 1)];
  return safeElapsed < FAST_COMPLETION_WINDOW_MS
    ? Math.min(scheduled, FAST_COMPLETION_MAX_DELAY_MS)
    : scheduled;
}

export function analysisRequestSignature(input: {
  mode: 'topic' | 'scan';
  subject?: string;
  grade?: string;
  topic?: string;
  difficulty?: string;
  instruction: string;
  teachingMode: 'answer' | 'explain';
  learningMode?: 'effective' | 'step-by-step';
  outputFormat: 'text' | 'video';
  image: string;
}): string {
  return JSON.stringify({
    mode: input.mode,
    subject: input.subject,
    grade: input.grade,
    topic: input.topic,
    difficulty: input.difficulty,
    instruction: input.instruction,
    teachingMode: input.teachingMode,
    ...(input.learningMode ? { learningMode: input.learningMode, outputFormat: input.outputFormat } : {}),
    imageSignature: input.image ? `${input.image.length}:${input.image.slice(0, 80)}` : '',
  });
}

export function generationRequestBody(
  input: Record<string, unknown>,
  providerResponseId = '',
  resumeToken = '',
): Record<string, unknown> {
  const isResumingVideo = input.outputFormat === 'video' && Boolean(providerResponseId && resumeToken);
  const safeInput = isResumingVideo
    ? Object.fromEntries(Object.entries(input).filter(([key]) => key !== 'image' && key !== 'presentationReference'))
    : input;
  return {
    ...safeInput,
    ...(providerResponseId ? { providerResponseId } : {}),
    ...(resumeToken ? { resumeToken } : {}),
  };
}
